import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

const checkboxSize = size(2);
const textSize = (props: any) => props.theme.font.size.regular;
const textLineHeight = (props: any) => props.theme.font.lineHeight.main;

export const Label = styled.label.withConfig({ componentId: 'sc-1iqod1e-0' })`
    position: relative;
    display: flex;
    align-items: flex-start;
    font-size: ${textSize};
    line-height: ${textLineHeight};
    user-select: none;
    cursor: default;

    &::before {
        content: "";
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: ${checkboxSize};
        height: ${checkboxSize};
        margin-top: calc((${checkboxSize} - ${textSize} * ${textLineHeight}) / -2);
        background-color: var(--c-input-selection-bg);
        color: var(--c-input-accent-fg);
        font-size: 1rem;
        border-radius: 3px;
        cursor: pointer;
    }
`;

export const Wrapper = styled((props: any) => <div {...props} />).attrs(({ type, checked }) => ({
  role: type || 'checkbox',
  'aria-checked': checked,
})).withConfig({ componentId: 'sc-1iqod1e-1' })`
    ${({ error }) =>
      error &&
      css`
            ${Label} {
                color: var(--c-input-error-text);

                &::before {
                    background-color: var(--c-semantic-error-100);
                }
            }
        `}
`;

type InputProps = Omit<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'ref'
>;

export const Input = styled(
  forwardRef<HTMLInputElement, InputProps>((props, ref) => (
    <input
      {...props}
      ref={ref}
      className={`${props.checked ? 'checked' : undefined} ${props.className}`}
    />
  )),
).attrs(({ type, checked }) => ({
  checked,
  type: type || 'checkbox',
})).withConfig({ componentId: 'sc-1iqod1e-2' })`
    position: fixed;
    left: -9999px;
    opacity: 0;

    &[disabled] {
        & + ${Label} {
            opacity: 0.37;
            cursor: not-allowed;
        }
    }
    &:checked,
    &.checked {
        & + ${Label} {
            &::before {
                background-color: var(--c-input-accent-bg);
                background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M12.3 3.3 6 9.6 3.7 7.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0l7-7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z" fill="%23FFFFFF"/></svg>');
                background-repeat: no-repeat;
                background-size: calc(${checkboxSize} * 0.625);
                background-position: 50%;
            }
        }
    }
`;

export const LabelText = styled.div.withConfig({ componentId: 'sc-1iqod1e-3' })`
    padding-left: ${size(1)};
    color: var(--c-text-main);
`;
